const numPhotos = 4;
//This Array keeps track of where we have moved photos
let indexArray = [];
// This array contains the actual image data (Bits)
let imageSrcArray = [];
// // Hide sorter
const showSorterElement = document.getElementById('containerSorter');
if (showSorterElement) showSorterElement.style.display = 'none';
function openSorter() {
    if (!showSorterElement) return;
    showSorterElement.style.display = 'flex';
    // Hide save button until user changes order.
    const button = document.getElementById('btnSavePhotosSorter');
    if (button) button.disabled = true;
}
function closeSorter() {
    if (!showSorterElement) return;
    showSorterElement.style.display = 'none';
}
// Set up "hidden" key combination to show sorter
// Control + M on Windows/Linux, Command + M on Mac
// Fallback: Alt + Shift + S (avoids browser/system shortcut conflicts)
document.addEventListener('keydown', function(e) {
    const key = (e.key || '').toLowerCase();
    const isPrimaryShortcut = (e.ctrlKey || e.metaKey) && (key === 'm' || e.code === 'KeyM');
    const isFallbackShortcut = e.altKey && e.shiftKey && (key === 's' || e.code === 'KeyS');
    if (isPrimaryShortcut || isFallbackShortcut) {
        e.preventDefault();
        openSorter();
    }
});
// Optional manual trigger from DevTools console: window.showSorter()
window.showSorter = openSorter;
window.hideSorter = closeSorter;
const closeSorterButton = document.getElementById('btnCloseSorter');
if (closeSorterButton) closeSorterButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeSorter();
});
// Add another slide to sorter collection
function addPhotoBox(index1, photo) {
    // Template for new photo element
    // const newItemHTML = `<div id="div${index}" ondrop="drop(event)"     ondragover="allowDrop(event)">
    //         <img src=${photo} draggable="true"
    //         ondragstart="drag(event)" class="fixed-ratio-img" id="drag${index}" width="190" height=140" />
    //       </div>`;
    // // Add to bottom of groupYear accordian segment
    // let newDiv = document.createElement('div');
    // newDiv.innerHTML = newItemHTML;
    // // Get a reference to an existing element
    // const dropBoxElement = document.getElementById('dropBoxes');
    // dropBoxElement.insertAdjacentHTML('beforeend', newDiv.innerHTML);
    const newDiv = document.createElement('div');
    newDiv.id = `div${index1}`;
    newDiv.ondrop = function(event) {
        drop(event);
    };
    newDiv.ondragover = function(event) {
        allowDrop(event);
    };
    const newImg = document.createElement('img');
    newImg.src = photo;
    newImg.draggable = true;
    newImg.ondragstart = function(event) {
        drag(event);
    };
    newImg.classList.add('fixed-ratio-img');
    newImg.style.webkitUserDrag = 'element';
    newImg.id = `drag${index1}`;
    newImg.width = 190;
    newImg.height = 140;
    newImg.dataset.boxId = newDiv.id;
    // Allow drops when pointer is directly over the image.
    newImg.ondragover = function(event) {
        allowDrop(event);
    };
    newImg.ondrop = function(event) {
        drop(event);
    };
    newDiv.appendChild(newImg);
    //document.body.appendChild(newDiv);
    console.log('newDiv=', newDiv);
    // // Get a reference to an existing element
    const dropBoxElement = document.getElementById('dropBoxes');
    console.log('dropBoxElement=', dropBoxElement);
    if (dropBoxElement) dropBoxElement.appendChild(newDiv);
}
function getSorterBoxIndexFromElement(el) {
    if (!el) return null;
    const box = el.closest('[id^="div"]');
    if (!box) return null;
    const raw = box.id.replace('div', '');
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? null : parsed;
}
function findActiveTripIndex(tripsArray) {
    let index1 = -1; // Initialize index to -1 as a "not found" indicator
    try {
        const openItem = document.getElementsByClassName('item open');
        if (openItem.length === 0) throw new Error('No open item found');
        const destination = openItem[0].getElementsByClassName('destination');
        if (destination.length === 0) throw new Error('No destination found in open item');
        const activeTripName = destination[0].innerText;
        //console.log('openItem=', openItem);
        //console.log('activeTripName=', activeTripName);
        // Assuming tripsArray is an array of objects that have a 'name' property
        index1 = tripsArray.findIndex((trip)=>trip.name === activeTripName);
        if (index1 === -1) throw new Error('Trip not found in array');
    } catch (error) {
        console.error(error.message);
        return null;
    }
    return index1; // Return the index, or -1 if not found
}
// Load up photo sorter images
document.querySelector('.btnLoadPhotosSorter').addEventListener('click', function(e) {
    e.preventDefault();
    console.log('btnLoadPhotos - Clicked');
    // Remove any existing photos from sorter
    const dropBoxElement = document.getElementById('dropBoxes');
    //console.log('dropBoxElement=', dropBoxElement);
    dropBoxElement.innerHTML = '';
    // Need to get name of open trip
    try {
        // array to keep track of photo positions by index
        indexArray = [];
        // Array to hold photo image data
        imageSrcArray = [];
        const activeTripIndex = findActiveTripIndex(window.tripsList);
        const activeTripData = window.tripsList[activeTripIndex];
        // Load the 4 photos we alread loaded onto sorter
        for(item = 0; item < 4; item++){
            imageSrcArray[item] = `data:image/jpeg;base64,${activeTripData.photoBufferLocal[item]}`;
            // Add photo and box to HTML
            addPhotoBox(item, imageSrcArray[item]);
            indexArray.push(item);
        }
        // Beyond the 4th photo, we need to load them
        loadRemaingPhotos(activeTripData);
    } catch (error) {
        alert('You must select a trip first');
    }
});
// Load rest of images
async function loadRemaingPhotos(trip) {
    const SMALLIMAGERESOLUTION = 300;
    const numPhotos = trip.photoId.length;
    if (typeof window.loadBufferImage !== 'function') {
        console.error('loadBufferImage is not available on window');
        return;
    }
    for(let item1 = 4; item1 < numPhotos; item1++){
        await window.loadBufferImage(trip.photoId[item1], trip, item1, SMALLIMAGERESOLUTION, 'local');
        // Add photo and box to HTML
        imageSrcArray[item1] = `data:image/jpeg;base64,${trip.photoBufferLocal[item1]}`;
        //console.log('imageSrcArray=', imageSrcArray);
        addPhotoBox(item1, imageSrcArray[item1]);
        // Continue to initialize idexArray
        indexArray.push(item1);
    }
}
// Save results of sorted photos
document.querySelector('.btnSavePhotosSorter').addEventListener('click', function(e) {
    e.preventDefault();
    console.log('btnSavePhotos - Clicked');
    const indexOriginal = findActiveTripIndex(window.tripsList);
    let originalTrip = window.tripsList[indexOriginal];
    //console.log('indexOriginal=', indexOriginal);
    //console.log('originalTrip=', originalTrip);
    // Create a deep copy if the object has nested arrays or objects
    let sortedTrip = JSON.parse(JSON.stringify(originalTrip));
    //console.log('sortedTrip=', sortedTrip);
    // Go thru trip properties and re-order them.
    for(index = 0; index < indexArray.length; index++)Object.entries(sortedTrip).forEach(([key, value])=>{
        //console.log(`key: ${key}, value: ${value}`);
        // Only process  properties that are not arrays
        if (Array.isArray(value)) //console.log('IsArrayKey=', key);
        // Use bracket notation for dynamic keys
        sortedTrip[key][index] = originalTrip[key][indexArray[index]];
    });
    //console.log('sortedTrip1=', sortedTrip);
    //console.log('sortedTrip=', sortedTrip);
    // Swap in the thip with the sorted data structure
    window.tripsList[indexOriginal] = sortedTrip;
    // RE-Load visable photos in active trip photo container
    // Find the first element with class "item open"
    const openItem = document.querySelector('.item.open');
    //console.log('openItem=', openItem);
    // If we find an item, find all photos within it with class "open"
    if (openItem) {
        // Get the 3 photo image divs and replace their image sources
        const openPhotos = openItem.querySelectorAll('.photo.open');
        for(fotoItem = 0; fotoItem < 3; fotoItem++){
            const photoElement = openPhotos[fotoItem];
            //console.log('photoElement=', photoElement);
            if (photoElement) {
                // Check if the element exists
                const photoElementAlt = photoElement.alt;
                const photoElementAltIndex = getTmageIndex(photoElementAlt);
                //console.log('photoElementAltIndex=', photoElementAltIndex);
                const testPhoto = window.tripsList[indexOriginal].photoBufferLocal[photoElementAltIndex];
                //console.log('testPhoto=', testPhoto);
                photoElement.src = `data:image/jpeg;base64,${testPhoto}`;
            }
        }
        // console.log(
        //   'window.tripsList[indexOriginal]=',
        //   window.tripsList[indexOriginal],
        // );
        // Save modifed trip to database
        const tripId = window.tripsList[indexOriginal]._id;
        //console.log('tripeId=', tripId);
        // We need a non-refrenced copy so we can remove the photo buffer data
        const subsetObj = Object.assign({}, window.tripsList[indexOriginal]);
        //Remove photo data as not part of database
        delete subsetObj.photoBufferLocal;
        // We want to save trip with index=0;
        Object.assign(subsetObj, {
            index: 0
        });
        //console.log('subsetObjM=', subsetObj);
        patchTrip(subsetObj, tripId);
        // Re-initialize arrays - ready for further sorting
        const indexLength = indexArray.length;
        indexArray = [];
        imageSrcArray = [];
        for(index = 0; index < indexLength; index++){
            indexArray[index] = index;
            imageSrcArray[index] = `data:image/jpeg;base64,${sortedTrip.photoBufferLocal[index]}`;
        }
        //console.log('indexArray - Save=', indexArray);
        //console.log('imageSrcArray - Save=', imageSrcArray);
        //Hide save button
        const button = document.getElementById('btnSavePhotosSorter');
        button.disabled = true;
    } else console.log('No item with class "item open" found');
});
// Prevent reload of page on drop
function allowDrop(ev) {
    console.log('allowDrop', ev);
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.dataTransfer) ev.dataTransfer.dropEffect = 'move';
}
function drag(ev) {
    console.log('drag', ev);
    ev.dataTransfer.setData('text', ev.target.id);
    //console.log('text=', ev.target.id);
    //console.log("target=", ev.target);
    //console.log("indexArray=", indexArray);
    const fromIndex = getSorterBoxIndexFromElement(ev.target);
    ev.dataTransfer.setData('fromIndex', fromIndex != null ? String(fromIndex) : '');
}
function drop(ev) {
    console.log('drop', ev);
    ev.preventDefault();
    ev.stopPropagation();
    // Required for Firefox to keep drag data valid
    ev.dataTransfer.getData('text');
    // Get index for image we are dragging from
    const fromIndexRaw = ev.dataTransfer.getData('fromIndex');
    const fromIndex = Number(fromIndexRaw);
    // Get index of image we are dragging to
    const toIndex = getSorterBoxIndexFromElement(ev.target);
    if (Number.isNaN(fromIndex) || toIndex == null || fromIndex === toIndex) return;
    //Remove item we are draging from array
    const draggedIndex = indexArray[fromIndex];
    indexArray.splice(fromIndex, 1);
    //Add back dragged itam index into Array
    indexArray.splice(toIndex, 0, draggedIndex);
    console.log('indexArray=', indexArray);
    //Load photos into their proper new positions
    reloadPhotos(indexArray);
    //Hide save button
    const button = document.getElementById('btnSavePhotosSorter');
    button.disabled = false;
}
//Load photos int0 their respective divs
function reloadPhotos(aryIndex) {
    aryIndex.forEach(loadImage);
}
function loadImage(item1, index1) {
    const dragID = 'drag' + index1;
    document.getElementById(dragID).src = imageSrcArray[item1];
}

//# sourceMappingURL=repo.a53939b2.js.map
